// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3aaddfc7","453":"89e64769","732":"a036bf91","977":"e87fe9df"}[chunkId] + ".chunk.js";
};